export const SET_FILTER_BY_SEARCH = 'SET_FILTER_BY_SEARCH';
export const SET_FILTER_BY_SECTIONS = 'SET_FILTER_BY_SECTIONS';
export const SET_FILTER_BY_STYLES = 'SET_FILTER_BY_STYLES';
export const SET_PAGES = 'SET_PAGES';
export const GET_SECTIONS_FILTER = 'GET_SECTIONS_FILTER';
export const GET_STYLES_FILTER = 'GET_STYLES_FILTER';

export const RESET_FILTER = 'RESET_FILTER';

// Constant for reducer type appointmentForm
export const GET_SERVICES_TYPE = 'GET_SERVICES_TYPE';
export const GET_BUILDING_TYPE = 'GET_BUILDING_TYPE';
export const GET_SECTIONS = 'GET_SECTIONS';
export const GET_STYLES = 'GET_STYLES';
export const SET_SECTIONS = 'SET_SECTIONS';
export const SET_STYLES = 'SET_STYLES';
export const SET_APPOINTMENT_REVIEWS = 'SET_APPOINTMENT_REVIEWS';
export const SET_CHECKBOX_SECTIONS = 'SET_CHECKBOX_SECTIONS';
export const SET_CHECKBOX_STYLES = 'SET_CHECKBOX_STYLES';

//Constant for user
export const SET_USER = 'SET_USER';
export const USER_LOGOUT = 'USER_LOGOUT';
export const TOKEN = 'TOKEN';

//Constant for Project projectDetails
export const GET_PROJECT_DETAIL_REQUEST = 'GET_PROJECT_DETAIL_REQUEST';
export const GET_PROJECT_DETAIL_SUCCES = 'GET_PROJECT_DETAIL_SUCCES';
export const GET_PROJECT_DETAIL_ERROR = 'GET_PROJECT_DETAIL_ERROR';

// Authentication
export const LOGIN_USER = 'LOGIN_USER';
